import React, { useEffect } from "react";
import { Navbar, Container } from "react-bootstrap";
//import { Link } from "react-router-dom";
import { DocumentFullScreen } from "@chiragrupani/fullscreen-react";
import ExamLayout from "../../components/ExamLayout/ExamLayout";
import Footer from "../../components/Footer/Footer";
import ExamSideNav from "./ExamSideNav/ExamSideNav";
import BgVideo from "./bgVideo/bgVideo";
import NoFaceModal from "./noFaceModal/noFaceModal";
import MultiFaceModal from "./multiFaceModal/multiFaceModal";
import ExitFullscreenModal from "./exitFullscreenModal/exitFullscreenModal";
import ConfirmSubmitModal from "./confirmSubmitModal/confirmSubmitModal";
import Timer from "./Timer/timer";
import HelpPopover from "../../components/helpPopover/helpPopover";
import { useDispatch, useSelector } from "react-redux";
import { setFullscreen } from "../../redux/features/fullScreen/fullScreenSlice";
//import { soundDetectionAndRecording,voiceDetection } from "../../redux/features/audioDetection/audioActions";
import StartExamModal from "./startExamModal/startExamModal";
import Recorder from "../../components/recorder/recorder";
import { counterUpdater } from "../../redux/features/timer/timerActions";
// styling
import "./ExamMain.page.css";
import Prompter from "../../components/Prompter/Prompter";

function ExamMainPage() {
  const isFullscreen = useSelector((state) => state.fullscreen.isFullscreen);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(counterUpdater());
  }, [dispatch]);
  // const handleShow = () => setShow(true);

  // useEffect(() => {
  //   dispatch(soundDetectionAndRecording());
  //   dispatch(voiceDetection())
  // }, [dispatch]);
  console.log("this component has rerendered");

  return (
    <>
      <DocumentFullScreen
        isFullScreen={isFullscreen}
        onChange={(isFull) => {
          dispatch(setFullscreen(isFull));
        }}
      >
        <div className="d-flex w-100 main-content position-relative">
          <BgVideo className="position-absolute top-50 start-50 translate-middle zindex-dropdown" />
          <div className="exam-content bg-Exam-body">
            <Navbar className="bg-white w-100 py-2" style={{ height: 60 }}>
              {/* mount recording component */}
              <Recorder />
              <Container className="d-flex justify-content-between px-5">
                <div></div>
                <HelpPopover />
              </Container>
            </Navbar>

            <div className="pb-4 pt-3 px-4">
              <Timer />
              <ExamLayout />
              <Footer />
            </div>
            {/* <BgVideo className="position-absolute top-50 start-50 translate-middle zindex-dropdown" /> */}
          </div>
          <ExamSideNav />
        </div>
        <div>
          <NoFaceModal />
        </div>
        <div>
          <MultiFaceModal />
        </div>
        <div>
          <ExitFullscreenModal />
        </div>
        <div>
          <ConfirmSubmitModal />
        </div>
        <StartExamModal />
        <Prompter />
      </DocumentFullScreen>
    </>
  );
}

export default ExamMainPage;
